<template>
  <div>
    <div class="m-wrapper" style="margin-top:18px;border-radius:0px;">
      <div id="titleBox">
          <span class="bigTitleInfo">Investment Recommendation</span>
        </div>
        <div id="splitLine"></div>

      <div class="filter-wrapper" style="margin-top: 30px">
        <div class="filter-content">
          <div class="filter clearfix">
            <div class="item">
              <div class="inner-wrapper">
                <div style="width: 125px" class="label">Batch</div>
                <div class="form">
                  <el-select
                    filterable
                    v-model="form.batchStr"
                    style="width: 100%"
                    popper-class="select-down"
                    size="small"
                    :popper-append-to-body="false"
                  >
                    <el-option
                      v-for="item in establishBatchArr"
                      :key="item.id"
                      :label="item.val"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="inner-wrapper">
                <div style="width: 90px" class="label">Key industry</div>
                <div class="form">
                  <el-select
                    filterable
                    v-model="form.chanYeStr"
                    style="width: 100%"
                    popper-class="select-down"
                    size="small"
                    :popper-append-to-body="false"
                  >
                    <el-option
                      v-for="item in chanYeDdb"
                      :key="item.id"
                      :label="item.val"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <!-- <div class="item">
              <div class="inner-wrapper">
                <div style="width: 80px" class="label">新企业数量</div>
                <div class="form-wrapper">
                  <div class="left input">
                    <el-input
                      size="small"
                      v-model="form.oneNewEntCount"
                      placeholder="请输入"
                      style="width: 100%"
                    >
                      <template slot="append">≤</template>
                    </el-input
                    >
                  </div>
                  <div class="middle">值</div>
                  <div class="right input">
                    <el-input
                      size="small"
                      v-model="form.twoNewEntCount"
                      placeholder="请输入"
                      style="width: 100%"
                    >
                      <template slot="prepend">≤</template>
                    </el-input
                    >
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-top: 10px" class="item">
              <div class="inner-wrapper">
                <div style="width: 80px" class="label">注册资本</div>
                <div class="form-wrapper">
                  <div class="left input">
                    <el-input
                      size="small"
                      v-model="form.oneRegistCapital"
                      placeholder="请输入"
                      style="width: 100%"
                    >
                      <template slot="append">≤</template>
                    </el-input>
                  </div>
                  <div class="middle">值</div>
                  <div class="right input">
                    <el-input
                      size="small"
                      v-model="form.twoRegistCapital"
                      placeholder="请输入"
                      style="width: 100%"
                    >
                      <template slot="prepend">≤</template>
                    </el-input>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-top: 10px" class="item">
              <div class="inner-wrapper">
                <div style="width: 80px" class="label">进出口总额</div>
                <div class="form-wrapper">
                  <div class="left input">
                    <el-input
                      size="small"
                      v-model="form.oneTmx"
                      placeholder="请输入"
                      style="width: 100%"
                    >
                      <template slot="append">≤</template>
                    </el-input
                    >
                  </div>
                  <div class="middle">值</div>
                  <div class="right input">
                    <el-input
                      size="small"
                      v-model="form.twoTmx"
                      placeholder="请输入"
                      style="width: 100%"
                    >
                      <template slot="prepend">≤</template>
                    </el-input>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <div class="filter-confirm">
          <div class="confirm-button" @click="getQueryList">Go</div>
        </div>

      </div>
      <div class="filter-confirm1" >

        <div class="confirm1_right" @click="explain">
          <i class="el-icon-warning-outline" style="color: #3897FF;font-size: 25px"></i>
        </div>
        <div class="confirm1_left">
          Specification
        </div>
      </div>
      <div class="center" style="padding: 20px 0">
        <!-- <FtaTable
          ref="FtaTable"
          :tableData="queryList"
          :column="queryColumn"
          height="300"
          :scrollStar="scrollStar"
          :diaLogShow="false"
        /> -->
        <FtaComplexTable
          :tableData="queryList"
          :headColumn="headColumn"
          :sortMethod="1"
          :clickFtn="1"
          :maxHeight="800"
          :changeSort="changeSort"
        />
      </div>
    </div>
    <el-dialog
      :visible.sync="isShow"
      width="980px"
      top="5"
      :before-close="handleClose">
      <div style="padding: 0px 45px">
        <div>
          <div class="item1">
           Calculation of index system weight:
          </div>
          <div class="item2">
            In FTZ recommendation model, the index weight is calculated by "entropy weight method". The importance of index is often associated with the information quantity of index in positive correlation. "Entropy weight method" uses index information entropy as information quantity. The information entropy of the standardized index data is calculated and normalized to obtain the weight.
          </div>
          <div class="item1" style="margin-top: 33px">
            Index system establishment:
          </div>
          <div class="item2">
           The idea of the investment index system is as follows: firstly, confirm the positionning of index system as decision reference for investors; secondly, learn from the domestic and foreign index system then focus on what investors concern, mainly referring to the index system of "Excellence in the FTZ", "World Bank Index System", etc; lastly, establish an index system including 5 first-grade indicators and 21 second-grade indicators based on the actual situation obtained by data.
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- <div class="m-wrapper" style="margin-top: 44px">
      <div style="position: relative; top: -24px">
        <FtaTitle title="自贸区推荐"/>
      </div>

      <div class="filter-wrapper">
        <div class="filter-content">
          <div class="filter clearfix">
            <div class="item" style="width: 100%;">
              <div class="inner-wrapper">
                <div style="width: 80px" class="label">成立批次</div>
                <div class="form">
                  <el-select
                    filterable
                    v-model="testVal"
                    style="width: 100%"
                    popper-class="select-down"
                    size="small"
                    :popper-append-to-body="false"
                  >
                    <el-option
                      v-for="item in test"
                      :key="item.id"
                      :label="item.val"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="padding: 30px 0">
        <FtaTable
          ref="newFtaTable"
          :tableData="tableData"
          :column="column"
          height="300"
          :scrollStar="newScrollStar"
          :diaLogShow="false"
        />
      </div>
    </div> -->
  </div>
</template>

<script>
import FtaHeader from '../component/FtaHeader'
import request from '../../../ftaUtils/http'
import baseUrl from '../../../ftaUtils/baseUrl'
import FtaTable from '../component/FtaTable'
import ChartBar from '../component/__ChartBar'
import ChartLine from '../component/ChartLine'
import ChartPie from '../component/ChartPie'
import FtaTitle from '../component/FtaTitle'
import FtaComplexTable from '../component/FtaComplexTable'
import {getCookieKey} from '../../../ftaUtils/util'

export default {
  name: 'InvestmentRecommend',
  components: {
    FtaTitle,
    FtaHeader,
    FtaTable,
    ChartBar,
    ChartLine,
    ChartPie,
    FtaComplexTable
  },
  data () {
    return {
      // 自贸区推荐，成立批次
      testVal: '',
      test: [],
      isShow: false,
      establishBatchArr: [],
      chanYeDdb:[],
      form: {
        batchStr: '',
        chanYeStr: '',
      },
      scrollStar: true,
      newScrollStar: true,
      value: '',
      queryList: [],
      headColumn:[
            {
                prop:'ftzBatch',
                label:'Batch',
                align:'center',
                width:100
            },
            {
                prop:'ftzName',
                label:'FTZ',
                align:'center',
                width:100
            },
            {
                prop:'indsName',
                label:'Key industry',
                align:'center',
                width:105

            },
            {
                prop:'total',
                label:'Total',
                align:'center',
                width:40,
                child:[
                    {
                    prop:'totalRank',
                    label:'Rank',
                    align:'center',
                      sortable:'custom',
                    style:'color:#FC7373',
                    width:20
                    },
                    {
                      // sortable:'custom',
                    prop:'totalScore',
                    label:'Score',
                    align:'center',
                    style:'color:#3447FF',
                    width:20
                    },
                ]
            },
            {
                prop:'economic',
                label:'Economic Strength',
                align:'center',
                // sortable:true,
                width:100,
                child:[
                    {
                      sortable:'custom',
                    prop:'economicRank',
                    label:'Rank',
                    align:'center',
                    style:'color:#FC7373',
                    width:50
                    },
                    {
                      // sortable:'custom',
                    prop:'economicScore',
                    label:'Score',
                    align:'center',
                    style:'color:#3447FF',
                    width:50
                    },
                ]
            },
            {
                prop:'friendly',
                label:'Urban Environment',
                align:'center',
                // sortable:true,
                width:100,
                child:[
                    {
                      sortable:'custom',
                    prop:'friendlyRank',
                    label:'Rank',
                    align:'center',
                    style:'color:#FC7373',
                    width:50
                    },
                    {
                      // sortable:'custom',
                    prop:'friendlyScore',
                    label:'Score',
                    align:'center',
                    style:'color:#3447FF',
                    width:50
                    },
                ]
            },

            {
                prop:'business',
                label:'Business Environment',
                align:'center',
                // sortable:true,
                width:110,
                child:[
                    {
                      sortable:'custom',
                    prop:'businessRank',
                    label:'Rank',
                    align:'center',
                    style:'color:#FC7373',
                    width:50
                    },
                    {
                      // sortable:'custom',
                    prop:'businessScore',
                    label:'Score',
                    align:'center',
                    style:'color:#3447FF',
                    width:50
                    },
                ]
            },
            {
                prop:'highQuality',
                label:'Quality Company Development',
                align:'center',
                // sortable:true,
                width:110,
                child:[
                    {
                      sortable:'custom',
                    prop:'highQualityRank',
                    label:'Rank',
                    align:'center',
                    style:'color:#FC7373',
                    width:50
                    },
                    {
                      // sortable:'custom',
                    prop:'highQualityScore',
                    label:'Score',
                    align:'center',
                    style:'color:#3447FF',
                    width:50
                    },
                ]
            },
            {
                prop:'innovation',
                label:'Innovation and Openness',
                align:'center',
                // sortable:true,
                width:110,
                child:[
                    {
                      sortable:'custom',
                    prop:'innovationRank',
                    label:'Rank',
                    align:'center',
                    style:'color:#FC7373',
                    width:50
                    },
                    {
                      // sortable:'custom',
                    prop:'innovationScore',
                    label:'Score',
                    align:'center',
                    style:'color:#3447FF',
                    width:50
                    },
                ]
            },

        ],
      column: [
        {
          prop: 'name',
          label: 'FTZ',
          align: 'center'
        }
      ],
      changeSort:true,
    }
  },
  methods: {
     handleClose (done) {
      this.$confirm('Are you sure to close the specification?')
        .then(_ => {
          this.isShow = false
          done()
        })
        .catch(_ => {})
    },
    // 使用说明
    explain () {
      this.isShow = true
    },
    // 获取下拉数据
    getselectData () {
      request('get', `${baseUrl.base_1}/advice/queryModelDdbInfo`).then(
        (res) => {
           this.establishBatchArr = [{val:'All',id:''},...res.data.batchDdb]
           this.chanYeDdb = [{val:'All',id:''},...res.data.chanYeDdb]
        }
      )
    },
    // 查询列表
    getQueryList () {
      request('get', `${baseUrl.base_1}/advice/queryRecommend`, {...this.form}).then(
        (res) => {
          let data = []
          res.data.forEach(element => {
            data.push({
              ftzId:element.ftzId,  // id
              ftzBatch:element.ftzBatch, // 成立批次
              ftzName:element.ftzName, // 自贸区名称
              indsName:element.indsName, // 重点产业

              totalRank:element.total.rank,  //总得分
              totalScore:element.total.score,

              economicRank:element.economic.rank, // 经济
              economicScore:element.economic.score,

              friendlyRank:element.friendly.rank, //友好的
              friendlyScore:element.friendly.score,

              businessRank:element.business.rank, // 商业
              businessScore:element.business.score,

              highQualityRank:element.highQuality.rank, // 高品质
              highQualityScore:element.highQuality.score,

              innovationRank:element.innovation.rank, //  创新
              innovationScore:element.innovation.score,


            })
          });
          this.queryList = data
          this.changeSort = !this.changeSort
          // this.queryList.forEach((item, index) => {
          //   item.num = index + 1
          // })
        }
      )
    },
    // getQueryEstablishBatchDropDownBox () {
    //   request('get', '/advice/queryEstablishBatchDropDownBox').then((res) => {
    //     this.establishBatchArr = res.data
    //     this.establishBatchArr.unshift({val: '全部', id: ''})
    //   })
    // },
    // doScroll (ref, flag) {
    //   const table = this.$refs[ref].$refs.table
    //   const divData = table.bodyWrapper
    //   divData.onmouseenter = () => {
    //     this[flag] = false
    //   }
    //   divData.onmouseleave = () => {
    //     this[flag] = true
    //   }
    // }
  },
  created () {
    const TS02b1f2d3 = getCookieKey('TS02b1f2d3')
    this.$store.commit('ftaToken', TS02b1f2d3)

  },
  mounted () {
    this.getselectData()
    this.getQueryList()
    // this.doScroll('FtaTable', 'scrollStar')
    // this.doScroll('newFtaTable', 'newScrollStar')
  }
}
</script>

<style src="../fta.css"  scoped></style>
<style lang="less"  src="./InvestmentRecommend.less"  scoped></style>

